import { setDataValue } from '@juvare/json-data-util';
import { walkWidgetConfigTree } from '../../walkWidgetConfigTree';
export function makeNewConfigUnique(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
rootConfig, editorPath, widgets, config) {
    if (!widgets) {
        widgets = [];
    }
    if (config.key) {
        const uniqueKeyCount = countUniqueKeys(rootConfig, widgets);
        let n = 0;
        while (n < 100) {
            const newRootConfig = JSON.parse(JSON.stringify(rootConfig));
            if (n === 0) {
                setDataValue(newRootConfig, editorPath, config);
                const newUniqueKeyCount = countUniqueKeys(newRootConfig, widgets);
                if (newUniqueKeyCount > uniqueKeyCount) {
                    return config;
                }
            }
            else {
                const newConfig = JSON.parse(JSON.stringify(config));
                newConfig.key = newConfig.key + n;
                if (typeof newConfig.label === 'string' && newConfig.label) {
                    newConfig.label = newConfig.label + ' ' + n;
                }
                setDataValue(newRootConfig, editorPath, newConfig);
                const newUniqueKeyCount = countUniqueKeys(newRootConfig, widgets);
                if (newUniqueKeyCount > uniqueKeyCount) {
                    return newConfig;
                }
            }
            ++n;
        }
    }
    return config;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function countUniqueKeys(rootConfig, widgets) {
    const fullKeys = new Set();
    walkWidgetConfigTree(rootConfig, widgets, (config, widget, param) => {
        let fullKey = param;
        if (config.key) {
            fullKey += (fullKey.length > 0 ? '.' : '') + config.key;
        }
        if (fullKey) {
            fullKeys.add(fullKey);
        }
        if (widget.childDynamicRows) {
            fullKey += (fullKey.length > 0 ? '.' : '') + '#';
        }
        return fullKey;
    }, '');
    return fullKeys.size;
}
